// extracted by mini-css-extract-plugin
module.exports = {"root":"CosmeticCreateEdit_root__27byT"};